export default __webpack_public_path__ + "static/englet-7-56cf9f16fcadf13255cfb462f85c561e.jpg";